import "./header.css";
import { Link } from "react-router-dom";
import { authSelector } from "../../store/selectors/index";
import { useSelector } from "react-redux";

const Header = () => {
  const { user } = useSelector(authSelector);

  return (
    <>
      <div className="fontHeading pt-1  pb-4 text-white">
        <h3 className="mt-6 ml-14 ">
          Site Management System (Sales,Inventory and Accounts System)
        </h3>
      </div>
      <div className="navR z-10 menu-bar w-full text-white pt-2 pb-3">
        <ul className="ml-14 w-3/5 flex justify-between cursor-pointer">
          <li className=" hover:bg-blue-500 p-2">File</li>
          <li className=" hover:bg-blue-500 p-2 ">
            Data Storage
            <div className="dropdown-menu ">
              <ul>
                {user.role === "admin" && (
                  <Link to="/registerUser">
                    <li className="hover:bg-blue-500 text-white">New User</li>
                  </Link>
                )}
              </ul>
            </div>
          </li>
          <li className=" hover:bg-blue-500 p-2 ">
            Reports
            <div className="dropdown-menu ">
              <ul>
                <li className="hover:bg-blue-500 text-white">
                  Daily Transaction
                  <div class="dropdown-menu-1">
                    <ul>
                      <li className="hover:bg-blue-500 text-white">
                        Sales
                        <div class="dropdown-menu-1">
                          <ul>
                            <Link to="/creditSaleSheetEntryWise">
                              <li className="hover:bg-blue-500 text-white">
                                Credit Sale Sheet Entry Wise
                              </li>
                            </Link>
                            <Link to="/creditSaleSheetCustomerVehicleWise">
                              <li className="hover:bg-blue-500 text-white">
                                Customer + Vehicle Wise Sheet
                              </li>
                            </Link>
                          </ul>
                        </div>
                      </li>
                    </ul>
                  </div>
                </li>
                <li className="hover:bg-blue-500 text-white">
                  Customer/Supplier Account
                  <div class="dropdown-menu-1">
                    <ul>
                      <Link to="/PLedger">
                        <li className="hover:bg-blue-500 text-white">
                          Party Ledger
                        </li>
                      </Link>
                    </ul>
                  </div>
                </li>
                <li className="hover:bg-blue-500 text-white">
                  Stock
                  <div class="dropdown-menu-1">
                    <ul>
                      <Link to="/stockBalance">
                        <li className="hover:bg-blue-500 text-white">
                          Stock Balance
                        </li>
                      </Link>

                      <Link to="/purchaseRegister">
                        <li className="hover:bg-blue-500 text-white">
                          Purchase Register
                        </li>
                      </Link>
                      <Link to="/saleRegister">
                        <li className="hover:bg-blue-500 text-white">
                          Sale Register
                        </li>
                      </Link>
                      <Link to="/bulkSaleRegister">
                        <li className="hover:bg-blue-500 text-white">
                          Bulk Sale Register
                        </li>
                      </Link>
                      <Link to="/bulkSalePurchaseReg">
                        <li className="hover:bg-blue-500 text-white">
                          Bulk Sale Purchase Register
                        </li>
                      </Link>
                      <Link to="/saleTaxInv">
                        <li className="hover:bg-blue-500 text-white">
                          Sale Tax Inv
                        </li>
                      </Link>
                    </ul>
                  </div>
                </li>

                <li className="hover:bg-blue-500 text-white">
                  Management
                  <div class="dropdown-menu-1">
                    <ul>
                      <Link to="/stockRegister">
                        {" "}
                        <li className="hover:bg-blue-500 text-white">
                          Fuel Sale Stock Register
                        </li>{" "}
                      </Link>
                    </ul>
                  </div>
                </li>
                <li className="hover:bg-blue-500 text-white">
                  Invoices and Summary
                  <div class="dropdown-menu-1">
                    <ul>
                      <Link to="/partyWiseBill">
                        <li className="hover:bg-blue-500 text-white">
                          Party Bill Vehicle Wise
                        </li>
                      </Link>
                      <Link to="/customerBSummary">
                        <li className="hover:bg-blue-500 text-white">
                          Customer Bill Summary
                        </li>
                      </Link>
                      <Link to="/customerIWise">
                        <li className="hover:bg-blue-500 text-white">
                          Customer B/S Item Wise
                        </li>
                      </Link>
                    </ul>
                  </div>
                </li>
              </ul>
            </div>
          </li>

          <li className="hover:bg-blue-500 p-2">Admin</li>
          <li className="hover:bg-blue-500 p-2">Help</li>
          <li className="hover:bg-blue-500 p-2">
            Accounts
            <div className="dropdown-menu ">
              <ul>
                <li className="hover:bg-blue-500 text-white">
                  Accounts Reports
                  <div class="dropdown-menu-1">
                    <ul>
                      <Link to="/GLedger">
                        <li className="hover:bg-blue-500 text-white">
                          General Ledger
                        </li>
                      </Link>
                      <Link to="/vehicleExp">
                        <li className="hover:bg-blue-500 text-white">
                          Vehicle Expense
                        </li>
                      </Link>

                      <Link to="/trialBalance">
                        <li className="hover:bg-blue-500 text-white">
                          Trial Balance
                        </li>
                      </Link>
                      <Link to="/profitLossReport">
                        <li className="hover:bg-blue-500 text-white">
                          Profit & Loss
                        </li>
                      </Link>
                      <Link to="/dailySheetNonPDFReport">
                        <li className="hover:bg-blue-500 text-white">
                          Daily Sheet
                        </li>
                      </Link>
                      <Link to="/logSheetReport">
                        <li className="hover:bg-blue-500 text-white">
                          Log Sheet
                        </li>
                      </Link>
                      <Link to="/tankLorryReport">
                        <li className="hover:bg-blue-500 text-white">
                          Tank Lorry Report
                        </li>
                      </Link>
                      <Link to="/rateGainReport">
                        <li className="hover:bg-blue-500 text-white">
                          Rate G/L
                        </li>
                      </Link>
                      <Link to="/dayBook">
                        <li className="hover:bg-blue-500 text-white">
                          Day Book
                        </li>
                      </Link>
                    </ul>
                  </div>
                </li>
              </ul>
              <ul>
                <li className="hover:bg-blue-500 text-white">
                  Verification
                  <div class="dropdown-menu-1">
                    <ul>
                      <Link to="/pendingApprovals">
                        <li className="hover:bg-blue-500 text-white">
                          Pending Approvals
                        </li>
                      </Link>
                    </ul>
                  </div>
                </li>
              </ul>
            </div>
          </li>
          <li className="hover:bg-blue-500 p-2">Day Data</li>
          <li className="hover:bg-blue-500 p-2">Day Reports</li>
        </ul>
      </div>
    </>
  );
};

export default Header;
